import { NeoModel, ModelBase, Attributes, Rules } from '@singularsystems/neo-core';
@NeoModel
export default class StaticServiceProviderModel extends ModelBase {

    @Rules.Required()
    @Attributes.Nullable()
    public staticServiceProviderId: number | null = null;

    public serviceProviderName: string = "";

    public serviceProviderCode: string = "";

    public serviceProviderSubAccountName: string = "";

    public serverName: string = "";
}